// Product Electronics page - Electronics hotspot configuration
// Uses HotspotManager from /js/pages/hotspot-manager.js

const electronicsParts = [
    {
        name: "Pickup Tone<br>Shaping<br>and<br>Compensation",
        description: "Shark Electronics includes a resistor and capacitor adjustment system accessible through dedicated DIP switches. These switches provide direct access to fundamental pickup electronic configurations.<br /><br />The system enables musicians to fine-tune pickup characteristics with remarkable precision and immediacy. By adjusting internal electronic parameters, players can achieve subtle to significant tonal variations without complex external equipment.",
        x: 76, y: 55,
        labelOffsetX: -6, labelOffsetY: 16,
        tabletX: 75, tabletY: 56,
        tabletLabelOffsetX: -4, tabletLabelOffsetY: 9,
        mobileX: 84, mobileY: 59,
        mobileLabelOffsetX: -5, mobileLabelOffsetY: 7,
        usePercentage: true
    },
    {
        name: "Battery Slot",
        description: "The central 9V battery powers the entire Shark Electronics system with robust energy delivery. This critical power source ensures consistent electrical supply across all electronic components. The battery supports active pickups, pedal cards, resistor-capacitor settings, and comprehensive onboard electronic functions with reliable, uninterrupted performance. It provides musicians with dependable power for complex signal processing and tone management.",
        x: 50, y: 56,
        labelOffsetX: 3, labelOffsetY: 17,
        tabletX: 50, tabletY: 56,
        tabletLabelOffsetX: -5, tabletLabelOffsetY: 13,
        mobileX: 52, mobileY: 61,
        mobileLabelOffsetX: -4, mobileLabelOffsetY: 9,
        usePercentage: true
    },
    {
        name: "Fx Card Slots",
        description: "The guitar features three dedicated slots designed to accommodate analog and digital effect cards directly on the instrument. These slots allow musicians to integrate multiple effects without external pedal boards.<br /><br />Every pedal parameter can be controlled from the front side of the guitar, enabling instant adjustments and precise tone modification. Musicians can manipulate effects in real-time, providing unprecedented control over their sound during performance.",
        x: 86, y: 45,
        labelOffsetX: 3, labelOffsetY: 20,
        tabletX: 85, tabletY: 45,
        tabletLabelOffsetX: -1, tabletLabelOffsetY: -15,
        mobileX: 95, mobileY: 46,
        mobileLabelOffsetX: -31, mobileLabelOffsetY: -12,
        usePercentage: true,
        additionalHotspots: [
            {
                x: 65.5, y: 48,
                tabletX: 64, tabletY: 47,
                mobileX: 69, mobileY: 49
            }
        ]
    }
];

let electronicsHotspotManager = null;
let imageLoaded = false;

function electronicsImageLoaded() {
    imageLoaded = true;
    createElectronicsContainer();
}

function createElectronicsContainer() {
    const preloadImg = document.getElementById('electronics-preload-image');
    if (!preloadImg) return;

    const imgWidth = preloadImg.naturalWidth;
    const imgHeight = preloadImg.naturalHeight;

    const imageContainer = document.getElementById('electronics-image-container');
    if (!imageContainer) return;

    imageContainer.innerHTML = `
        <div class="interactive-container" id="electronics-container" style="overflow:unset; margin:0 auto;">
            <img src="${preloadImg.src}" alt="Electronics Detail" class="electronics-image" id="electronics-image" width="${imgWidth}" height="${imgHeight}">
        </div>
        <div class="mobile-overlay"></div>
        <div class="mobile-hotspot-info">
            <div class="mobile-hotspot-close">×</div>
            <h3 class="mobile-hotspot-title"></h3>
            <p class="mobile-hotspot-description"></p>
        </div>
    `;

    // Create description panel for desktop view
    const deviceType = window.innerWidth <= 768 ? 'mobile' : (window.innerWidth <= 1024 ? 'tablet' : 'desktop');
    if (deviceType === 'desktop') {
        const electronicsSection = document.querySelector('.electronics-section');
        if (electronicsSection) {
            const existingPanel = document.getElementById('electronics-description-panel');
            if (existingPanel) existingPanel.remove();

            const descriptionPanel = document.createElement('div');
            descriptionPanel.id = 'electronics-description-panel';
            descriptionPanel.className = 'electronics-description-panel';
            descriptionPanel.innerHTML = `
                <h4 class="description-title">Select a feature</h4>
                <p class="description-text">Hover over or tap on any point to learn more about our electronics features.</p>
            `;
            electronicsSection.appendChild(descriptionPanel);
        }
    }

    setTimeout(() => {
        electronicsHotspotManager = new HotspotManager({
            containerId: 'electronics-container',
            parts: electronicsParts,
            hasLearnMore: false,
            hasOverlay: true,
            hasDescriptionPanel: deviceType === 'desktop',
            descriptionPanelSelector: '#electronics-description-panel',
            useEmUnits: true,
            defaultCircleSize: { mobile: 50, tablet: 75, desktop: 100 }
        });

        electronicsHotspotManager.createHotspots('electronics-container', electronicsParts);
        electronicsHotspotManager.setupMobileInteractions();
    }, 100);
}

document.addEventListener('DOMContentLoaded', function () {
    imageLoaded = false;

    const preloadImg = document.getElementById('electronics-preload-image');
    if (preloadImg) {
        if (preloadImg.complete) {
            electronicsImageLoaded();
        } else {
            preloadImg.onload = electronicsImageLoaded;
        }
    }

    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (imageLoaded) {
                createElectronicsContainer();
            }
        }, 250);
    });
});
